import { render, staticRenderFns } from "./BatchPaymentDialog.vue?vue&type=template&id=2d363d7e&scoped=true"
import script from "./BatchPaymentDialog.vue?vue&type=script&lang=js"
export * from "./BatchPaymentDialog.vue?vue&type=script&lang=js"
import style0 from "./BatchPaymentDialog.vue?vue&type=style&index=0&id=2d363d7e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d363d7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d363d7e')) {
      api.createRecord('2d363d7e', component.options)
    } else {
      api.reload('2d363d7e', component.options)
    }
    module.hot.accept("./BatchPaymentDialog.vue?vue&type=template&id=2d363d7e&scoped=true", function () {
      api.rerender('2d363d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/BatchPaymentDialog.vue"
export default component.exports